"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _ProgramSettings_ProgramId, _ProgramSettings_Timestamp, _ProgramSettings_AccountId, _ProgramSettings_SensitivePrintExpiration, _ProgramSettings_ApiKeys;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgramSettings = void 0;
const _1 = require(".");
class ProgramSettings {
    constructor(programSettingItem) {
        _ProgramSettings_ProgramId.set(this, void 0);
        _ProgramSettings_Timestamp.set(this, void 0);
        _ProgramSettings_AccountId.set(this, void 0);
        _ProgramSettings_SensitivePrintExpiration.set(this, void 0);
        _ProgramSettings_ApiKeys.set(this, void 0);
        __classPrivateFieldSet(this, _ProgramSettings_ProgramId, programSettingItem.ProgramId, "f");
        __classPrivateFieldSet(this, _ProgramSettings_Timestamp, programSettingItem.Timestamp || Date.now(), "f");
        __classPrivateFieldSet(this, _ProgramSettings_AccountId, programSettingItem.AccountId || "", "f");
        __classPrivateFieldSet(this, _ProgramSettings_SensitivePrintExpiration, programSettingItem.SensitivePrintExpiration || 0, "f");
        __classPrivateFieldSet(this, _ProgramSettings_ApiKeys, {}, "f");
        for (const stage in _1.ProgramStage) {
            const apiKeyName = (0, _1.buildApiKeyName)(_1.ProgramStage[stage]);
            __classPrivateFieldGet(this, _ProgramSettings_ApiKeys, "f")[apiKeyName] = programSettingItem[apiKeyName];
        }
    }
    getProgramId() {
        return __classPrivateFieldGet(this, _ProgramSettings_ProgramId, "f");
    }
    getAccountId() {
        return __classPrivateFieldGet(this, _ProgramSettings_AccountId, "f");
    }
    getSensitivePrintExpiration() {
        return __classPrivateFieldGet(this, _ProgramSettings_SensitivePrintExpiration, "f");
    }
    isSensitivePrintsEnabled() {
        return !isNaN(__classPrivateFieldGet(this, _ProgramSettings_SensitivePrintExpiration, "f")) && __classPrivateFieldGet(this, _ProgramSettings_SensitivePrintExpiration, "f") > Date.now();
    }
    getApiKey(programStage) {
        return __classPrivateFieldGet(this, _ProgramSettings_ApiKeys, "f")[(0, _1.buildApiKeyName)(programStage)];
    }
    toString() {
        return JSON.stringify({
            ProgramId: __classPrivateFieldGet(this, _ProgramSettings_ProgramId, "f"),
            Timestamp: __classPrivateFieldGet(this, _ProgramSettings_Timestamp, "f"),
            AccountId: __classPrivateFieldGet(this, _ProgramSettings_AccountId, "f"),
            SensitivePrintExpiration: __classPrivateFieldGet(this, _ProgramSettings_SensitivePrintExpiration, "f"),
            ApiKeys: __classPrivateFieldGet(this, _ProgramSettings_ApiKeys, "f")
        });
    }
}
exports.ProgramSettings = ProgramSettings;
_ProgramSettings_ProgramId = new WeakMap(), _ProgramSettings_Timestamp = new WeakMap(), _ProgramSettings_AccountId = new WeakMap(), _ProgramSettings_SensitivePrintExpiration = new WeakMap(), _ProgramSettings_ApiKeys = new WeakMap();
//# sourceMappingURL=programSettings.js.map